import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  searchUserText: '',
  contentType: {
    Documents: true,
    ExternalLinks: true,
    Pages: true,
  },
  displayOnPortal: false,
  recordsPerPage: 10,
  pageNumber: 1,
};

export const manageResourceSlice = createSlice({
  name: 'manageResource',
  initialState: INITIAL_STATE,
  reducers: {
    setSearchUserText: (state, action) => {
      state.searchUserText = action.payload;
    },
    setContentType: (state, action) => {
      state.contentType = action.payload;
    },
    setDisplayOnPortal: (state, action) => {
      state.displayOnPortal = action.payload;
    },
    setRecordsPerPage: (state, action) => {
      state.recordsPerPage = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },

    resetManageResource: (state, action) => {
      state.searchUserText = INITIAL_STATE.searchUserText;
      state.contentType = INITIAL_STATE.contentType;
      state.displayOnPortal = INITIAL_STATE.displayOnPortal;
      state.recordsPerPage = INITIAL_STATE.recordsPerPage;
      state.pageNumber = INITIAL_STATE.pageNumber;
    },
  },
});

export const {
  setSearchUserText,
  setRecordsPerPage,
  setContentType,
  setDisplayOnPortal,
  setPageNumber,
  resetManageResource,
} = manageResourceSlice.actions;

export default manageResourceSlice.reducer;
